import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isLoading", "name", "value", "onChange", "icon"];
import { Search } from "lucide-react";
import React from "react";
import TextInput from "../TextInput";
import { jsx as _jsx } from "react/jsx-runtime";
var SearchInput = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? Search : _ref$icon,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(TextInput, _extends({
    ref: forwardedRef,
    adornStart: icon && {
      type: "icon",
      props: {
        icon: icon
      }
    },
    adornEnd: isLoading && {
      type: "spinner"
    },
    name: name,
    value: value,
    onChange: onChange
  }, restProps));
});
SearchInput.displayName = "SearchInput";
export default SearchInput;